// keep together

export const ACTIVITY_SHARES_EMPLOYEE_FORBIDDEN = 'activity/shares_employee_forbidden';
export const ACTIVITY_ERROR_INVAlID_CREATE_PARAMS = 'activity/invalid_create_params';

export const AUTH_ERROR_ACCOUNT_VERIFIED = 'auth/account_verified';
export const AUTH_ERROR_ACCOUNT_ARCHIVED = 'auth/account_archived';
export const AUTH_ERROR_ACCOUNT_DENIED = 'auth/account_denied';
export const AUTH_ERROR_INTEGRITY_CHECK = 'auth/integrity_check';
export const PROFILE_ERROR_ACCOUNT_CLOSED = 'profile/account_closed';
export const PROFILE_CLOSE_ERROR_REQUIREMENT_NOT_MET = 'profile/close_error_requirement_not_met';
export const AUTH_ERROR_NOT_FOUND = 'auth/not_found';
export const AUTH_ERROR_ATTEMPTS_BLOCKED = 'auth/attempts_blocked';
export const AUTH_ERROR_REFRESH_TOKEN_INVALID = 'auth/invalid_refresh_token';
export const AUTH_ERROR_DEVICE_TOKEN_NOT_FOUND = 'auth/device_token_not_found';
export const AUTH_ERROR_PHONE_NUMBER_ALREADY_EXIST = 'auth/phone_number_already_exist';
export const AUTH_ERROR_USERNAME_ALREADY_TAKEN = 'auth/username_already_taken';
export const AUTH_ERROR_DEVICE_ALREADY_TAKEN = 'auth/device_already_taken';
export const AUTH_ERROR_EMAIL_ALREADY_TAKEN = 'auth/email_already_taken';
export const AUTH_ERROR_EMAIL_DOMAIN_NOT_SUPPORTED = 'auth/email_domain_not_supported';
export const AUTH_ERROR_DEVICE_NOT_FOUND = 'auth/device_not_found';
export const AUTH_ERROR_EMAIL_NOT_FOUND = 'auth/email_not_found';
export const AUTH_ERROR_EMAIL_ALREADY_VERIFIED = 'auth/email_already_verified';
export const AUTH_ERROR_RESET_PIN_WRONG_DEVICE_TOKEN = 'auth/reset_pin/wrong_device_token';
export const AUTH_EXCLUSIVE_INVITE_CODE_REQUIRED = 'auth/exclusive_invite_code_required';
export const AUTH_RESET_PHONE_NUMBER_REQUEST_NOT_FOUND =
  'auth/reset_phone_number_request_not_found';
export const AUTH_RESET_PHONE_NUMBER_INVALID_INPUT = 'auth/reset_phone_number_invalid_input';
export const AUTH_DISPLAY_NAME_REQUIRED = 'auth/display_name_required';
export const AUTH_COMPANY_ALREADY_EXISTS = 'auth/company_already_exists';
export const AUTH_COMPANY_DOCUMENTS_NOT_UPLOADED = 'auth/company_documents_not_uploaded';
export const AUTH_COMPANY_INVALID_LEGAL_CATEGORY = 'auth/company_invalid_legal_category';
export const AUTH_POA_ALREADY_UPLOADED = 'auth/poa_already_uploaded';

export const CHAT_GROUP_ERROR_IMAGE_PATH_INVALID = 'chat_group/invalid_image_path';
export const CHAT_GROUP_ERROR_INVALID_IMAGE = 'chat_group/invalid_image';

export const CHAT_ERROR_CHANNEL_NO_ACCESS = 'chat/channel_no_access';

export const EXPLORE_ERROR_INVALID_STOCK = 'explore/invalid_stock';
export const EXPLORE_ERROR_INVALID_FEE_FREE_ORDERS_REMAINING =
  'explore/invalid_fee_free_orders_remaining';
export const EXPLORE_ERROR_INVALID_ORDER = 'explore/invalid_order';
export const EXPLORE_ERROR_INVALID_CURRENCY = 'explore/invalid_currency';
export const EXPLORE_ERROR_INSUFFICIENT_BALANCE = 'explore/insufficient_balance';
export const EXPLORE_ERROR_BELOW_MINIMUM_ORDER = 'explore/below_minimum_order';
export const EXPLORE_ERROR_FLAT_FEE_BELOW_MINIMUM_ORDER = 'explore/flat_fee_below_minimum_order';
export const EXPLORE_ERROR_BELOW_CB_MIN_FUNDS = 'explore/below_cb_min_funds';
export const EXPLORE_ERROR_INSUFFICIENT_SHARES = 'explore/insufficient_shares';
export const EXPLORE_ERROR_PENDING_ORDER = 'explore/pending_order';
export const EXPLORE_ERROR_INVALID_INPUT = 'explore/invalid_input';
export const EXPLORE_ERROR_DOCUMENT_NOT_FOUND = 'explore/document_not_found';
export const EXPLORE_ERROR_CRYPTO_TRANSFER_WALLET_NOT_FOUND =
  'explore/crypto_transfer_wallet_not_found';
export const EXPLORE_ERROR_CRYPTO_TRANSFER_NOT_SUPPORTED = 'explore/crypto_transfer_not_supported';
export const EXPLORE_ERROR_CRYPTO_TRANSFER_NOT_CANCELLABLE =
  'explore/crypto_transfer_not_cancellable';
export const EXPLORE_ERROR_RECURRING_ORDER_IN_PROCESS = 'explore/recurring_order_in_process';
export const EXPLORE_ERROR_RECURRING_ORDER_NOT_FOUND = 'explore/recurring_order_not_found';
export const EXPLORE_ERROR_VERIFICATION_DEPOSIT_REQUIRED = 'explore/verification_deposit_required';
export const EXPLORE_ERROR_BUSINESS_LEI_NOT_ACTIVE = 'explore/business_lei_not_active';
export const EXPLORE_ERROR_AMOUNTS_DO_NOT_MATCH = 'explore/amounts_do_not_match';
export const EXPLORE_ERROR_DUPLICATE_INSTRUMENT_ALLOCATION =
  'explore/duplicate_instrument_allocation';
export const EXPLORE_ERROR_MULTIPLE_PILOTE_ALLOCATION = 'explore/multiple_pilote_allocation';
export const EXPLORE_ERROR_MIXED_TAX_WRAPPERS = 'explore/mixed_tax_wrappers';
export const EXPLORE_ERROR_COMPARTMENT_NOT_ARBITRABLE = 'explore/compartment_not_arbitrable';
export const EXPLORE_ERROR_TOO_MANY_ALLOCATIONS = 'explore/too_many_allocations';
export const EXPLORE_ERROR_SAVINGS_NOT_ENABLED = 'explore/savings_not_enabled';
export const EXPLORE_ERROR_SAVINGS_CAMPAIGN_NOT_FOUND = 'explore/savings_campaign_not_found';
export const EXPLORE_ERROR_SAVINGS_CAMPAIGN_AMOUNT_INVALID =
  'explore/savings_campaign_amount_invalid';
export const EXPLORE_ERROR_SAVINGS_CAMPAIGN_PAYOUT_NOT_SUPPORTED =
  'explore/savings_campaign_payout_not_supported';
export const EXPLORE_ERROR_SAVINGS_CAMPAIGN_INVESTMENT_FORBIDDEN =
  'explore/savings_campaign_investment_forbidden';
export const EXPLORE_ERROR_SAVINGS_CAMPAIGN_INSTRUMENT_INVALID =
  'explore/savings_campaign_instrument_invalid';
export const EXPLORE_ERROR_SAVINGS_DUPLICATE_ALLOCATIONS =
  'explore/savings_campaign_duplicate_allocations';
export const EXPLORE_ERROR_SAVINGS_PLAN_NOT_FOUND = 'explore/savings_plan_not_found';
export const EXPLORE_ERROR_SAVINGS_PROFILE_INVALID_AGE = 'explore/savings_profile_invalid_age';
export const EXPLORE_ERROR_DEDUCTIBLE_AGE_LIMIT_EXCEEDED = 'explore/deductible_age_limit_exceeded';
export const B2B_ARBITRAGE_NOT_CONFIRMED =
  'The provider did not confirm the arbitrage, it is forwarded for manual handling: do not retry';
export const EXPLORE_HAS_RESTRICTIONS = 'explore/has_restrictions';
export const EXPLORE_ERROR_AMOUNT_EXCEEDS_VESTED = 'explore/amount_exceeds_vested';

export const INVALID_SAVING_PLAN_TYPE = 'explore/invalid_saving_plan_type';
export const EXPLORE_DEDUCTIBILITY_AND_PLAN_TYPE_DONT_MATCH =
  'explore/deductibility_and_plan_type_dont_match';

export const EXPLORE_ERROR_SAVINGS_MISSING_TOCS =
  'explore/savings_plan_missing_terms_and_conditions';
export const EXPLORE_ERROR_SAVINGS_PLAN_NOT_SUPPORTED = 'explore/savings_plan_not_supported';
export const EXPLORE_ERROR_MULTIPLE_INVESTMENT_ACCOUNT_NOT_SUPPORTED =
  'explore/multiple_investment_account_not_supported';
export const EXPLORE_ERROR_FULLY_MANAGED_PLAN_ALLOCATION_MISMATCH =
  'explore/fully_managed_plan_allocation_mismatch';
export const EXPLORE_ERROR_INVESTOR_PROFILE_NOT_SET = 'explore/investor_profile_not_set';
export const EXPLORE_ERROR_UNKNOWN_ERROR_DURING_VALIDATION =
  'explore/unknown_error_during_validation';
export const EXPLORE_ERROR_INSTRUMENT_NOT_ENABLED_FOR_PLAN =
  'explore/instrument_not_enabled_for_plan';
export const EXPLORE_ERROR_INSTRUMENT_ORDER_NOT_ENABLED_FOR_PLAN =
  'explore/instrument_order_not_enabled_for_plan';
export const EXPLORE_ERROR_INSTRUMENT_LOCKED_FOR_PLAN = 'explore/instrument_locked_for_plan';

export const EXPLORE_ERROR_CAN_NOT_FETCH_UPCOMING_EVENTS_FOR_TAIGA_PLANS =
  'explore/can_not_fetch_upcoming_events_for_taiga_plans';

export const EXPLORE_UNKNOWN_TRANSACTION_TYPE = 'explore/unknown_transaction_type';

export const EXPLORE_UNEXPECTED_TRANSACTION_TYPE = 'explore/unexpected_transaction_type';

export const EXPLORE_TRANSACTION_WITH_NO_BREAKDOWN = 'explore/transaction_with_no_breakdown';

export const EXPLORE_TRANSACTION_NOT_FOUND = 'explore/transaction_not_found';

export const EXPLORE_FAILED_TO_CANCEL_ORDER = 'explore/failed_to_cancel_order';

export const FRIEND_ERROR_FORBIDDEN = 'friends/forbidden';
export const FRIEND_ERROR_LIMIT = 'friends/limit';
export const FRIEND_ERROR_ALREADY_EXIST = 'friends/already_exist';
export const FRIEND_ERROR_USER_NOT_FOUND = 'friends/user_not_found';
export const FRIEND_ERROR_REQUEST_NOT_FOUND = 'friends/request_not_found';

export const INSTRUMENT_ERROR_LIMIT = 'instruments/limit';
export const INSTRUMENT_NOT_ENABLED = 'instruments/not_enabled';
export const INSTRUMENT_NOT_TRADABLE = 'instruments/not_tradable';
export const INSTRUMENT_SUSPENDED = 'instruments/suspended';
export const TERMS_AND_CONDITIONS_NOT_SIGNED = 'instruments/terms_and_conditions_not_signed';
export const INSTRUMENT_TYPE_NOT_SUPPORTED = 'instruments/type_not_supported';
export const INSTRUMENT_ERROR_NOT_FOUND = 'instruments/not_found';
export const INSTRUMENT_ERROR_INVALID = 'instruments/invalid';
export const INSTRUMENT_ERROR_INVALID_WATCHLISTS = 'instruments/invalid_watchlists';
export const INSTRUMENT_NOT_ALLOWED_ON_PER = 'instruments/not_allowed_on_per';

export const PROFILE_ERROR_RESTRICTED = 'profile/restricted';
export const PROFILE_ERROR_REQUIREMENT_NOT_MET = 'profile/requirement_not_met';
export const PROFILE_FORBIDDEN_REPORT_OWN_PROFILE = 'profile/forbidden_report_own_profile';
export const PROFILE_ERROR_NOT_SAVINGS = 'profile/not_savings';
export const PROFILE_ERROR_NOT_BUSINESS = 'profile/not_business';
export const PROFILE_COMPANY_LEI_SUBMITTED = 'profile/company/lei_submitted';
export const PROFILE_ERROR_EMAIL_DOMAIN_NOT_SUPPORTED = 'profile/email_domain_not_supported';
export const PROFILE_ERROR_EMAIL_ALREADY_VERIFIED = 'profile/email_already_verified';
export const PROFILE_ERROR_EMAIL_ALREADY_TAKEN = 'profile/email_already_taken';
export const PROFILE_POA_ALREADY_UPLOADED = 'profile/poa_already_uploaded';
export const PROFILE_POA_DOCUMENTS_REQUIRED = 'profile/poa_documents_required';
export const PROFILE_ADDRESS_POSTAL_CITY_MISMATCH = 'profile/address_postal_city_mismatch';
export const PROFILE_TASK_NOT_FOUND = 'profile/task_not_found';
export const PROFILE_WALLET_NOT_FOUND = 'profile/wallet_not_found';
export const PROFILE_WALLET_ALREADY_EXISTS = 'profile/wallet_already_exists';
export const PROFILE_WALLET_INVALID_ADDRESS = 'profile/wallet_invalid_address';
export const PROFILE_WALLET_INVALID_NETWORK = 'profile/wallet_invalid_network';
export const PROFILE_WALLET_HAS_PENDING_TRANSFER = 'profile/wallet_has_pending_transfer';

export const QUESTIONS_ERROR_INVALID_BIRTHDATE = 'questions/invalid_birthdate';
export const QUESTIONS_ERROR_FIRSTNAME_REQUIRED = 'questions/firstname_required';
export const QUESTIONS_ERROR_LASTNAME_REQUIRED = 'questions/lastname_required';
export const QUESTIONS_ERROR_ONBOARDING_STARTED_ALREADY = 'questions/onboarding_started_already';
export const QUESTIONS_ERROR_INVALID_ANNUAL_INDEX = 'questions/invalid_annual_index';
export const QUESTIONS_ERROR_INVALID_FREE_STOCK = 'questions/invalid_free_stock';
export const QUESTIONS_ERROR_UNSUPPORTED_COUNTRY = 'questions/unsupported_country';
export const QUESTIONS_ERROR_SERVICE_UNAVAILABLE = 'questions/service_unavailable';
export const QUESTIONS_ERROR_DOC_ALREADY_UPLOADED = 'questions/documents_already_uploaded';
export const QUESTIONS_ERROR_BENEFICIARY_ALREADY_CREATED = 'questions/beneficiary_already_created';
export const QUESTIONS_ERROR_INVALID_STREET = 'questions/invalid_street';
export const QUESTIONS_ERROR_INVALID_CITY = 'questions/invalid_city';
export const QUESTIONS_ERROR_INVALID_POSTAL_CODE = 'questions/invalid_postal_code';
export const QUESTIONS_ERROR_TAX_NUMBER = 'questions/tax_number';
export const QUESTIONS_ERROR_UNSUPPORTED_BUSINESS_RANGES = 'questions/company/unsupported_ranges';
export const QUESTIONS_ERROR_UBO_LIST_UNAVAILABLE = 'questions/company/ubo_list_unavailable';
export const QUESTIONS_ERROR_DIRECTORS_LIST_UNAVAILABLE =
  'questions/company/directors_list_unavailable';
export const QUESTIONS_ERROR_NO_SOURCE_OF_FUNDS = 'questions/no_source_of_funds';
export const QUESTIONS_ERROR_SOF_DOCUMENTS_ALREADY_UPLOADED =
  'questions/sof_documents_already_uploaded';
export const QUESTIONS_INVALID_EMPLOYMENT_STATUS = 'questions/invalid_employment_status';
export const QUESTIONS_ERROR_REQUIREMENT_NOT_MET = 'questions/requirement_not_met';

export const DEBIT_CARDS_LINKED_CARD_NOT_FOUND = 'debit_cards/linked_card_not_found';
export const DEBIT_CARDS_WITHDRAW_NOT_SUPPORTED = 'debit_cards/withdraw_not_supported';
export const DEBIT_CARDS_ALREADY_ADDED = 'debit_cards/already_added';
export const DEBIT_CARDS_CARD_HOLDER_NAME_MATCHING_FAILED =
  'debit_cards/card_holder_name_matching_failed';
export const DEBIT_CARDS_WRONG_PAYMENT_ACCESS = 'debit_cards/wrong_payment_access';
export const DEBIT_CARDS_ALREADY_LINKED_TO_ANOTHER_USER =
  'debit_cards/already_linked_to_another_user';
export const DEBIT_CARDS_ALREADY_UNLINKED = 'debit_cards/debit_cards_already_unlinked';
export const DEBIT_CARDS_CANNOT_UNLINK = 'debit_cards/debit_cards_cannot_unlink';
export const DEBIT_CARDS_UNLINK_PENDING_TRANSACTIONS =
  'debit_cards/debit_cards_cannot_pending_transactions';
export const DEBIT_CARDS_CANNOT_LINK = 'debit_cards/debit_cards_cannot_link';
export const DEBIT_CARDS_TOKEN_INVALID = 'debit_cards/debit_cards_token_invalid';
export const DEBIT_CARDS_APPLE_PAY_TOKEN_INVALID =
  'debit_cards/debit_cards_apple_pay_token_invalid';
export const DEBIT_CARDS_APPLE_PAY_NOT_LINKED = 'debit_cards/apple_pay_not_linked';
export const DEBIT_CARDS_CARD_EXPIRED = 'debit_cards/card_expired';
export const DEBIT_CARDS_MAX_DEPOSIT_EU = 'debit_cards/max_deposit_eu';
export const DEBIT_CARDS_MIN_DEPOSIT = 'debit_cards/debit_cards_min_deposit';
export const CO_CARD_TOP_UP_CREDIT_CARD_NOT_SUPPORTED = 'funding/credit_card_not_supported';
export const CO_CARD_TOP_UP_PREPAID_CARD_NOT_SUPPORTED = 'funding/prepaid_card_not_supported';
export const CO_CARD_TOP_UP_NOT_FOUND = 'funding/co_card_top_up_not_found';
export const CO_CARD_TOP_UP_CORRELATION_ID_REQUIRED =
  'funding/co_card_top_up_correlation_id_required';
export const TRANSFER_UNSUPPORTED_TRANSITION = 'transfer/unsupported_transition';
export const FUNDING_DEPOSIT_AMOUNT_INVALID = 'funding/deposit_amount_invalid';

export const FUNDING_MISSING_INSTITUTION_ID = 'funding/missing_institution_id';
export const FUNDING_MISSING_INSTITUTION = 'funding/missing_institution';
export const FUNDING_WITHDRAWAL_ALLOCATIONS_INVALID = 'funding/withdrawal_allocations_invalid';
export const FUNDING_WITHDRAWAL_INSUFFICIENT_BALANCE = 'funding/withdrawal_insufficient_balance';
export const FUNDING_WITHDRAWAL_BENEFICIARY_INVALID = 'funding/withdrawal_beneficiary_invalid';
export const FUNDING_WITHDRAWAL_ALREADY_APPROVED = 'funding/withdrawal_already_approved';
export const FUNDING_WITHDRAWAL_TASK_NOT_FOUND = 'funding/withdrawal_task_not_found';
export const FUNDING_WITHDRAWAL_IRREVOCABILITY_NOT_ACKNOWLEDGED =
  'funding/withdrawal_irrevocability_not_acknowledged';
export const FUNDING_SEPA_DD_MANDATE_NOT_SIGNABLE = 'funding/sepa_dd_mandate_not_signable';
export const FUNDING_SEPA_DD_MANDATE_ALREADY_EXISTS = 'funding/sepa_dd_mandate_already_exists';
export const FUNDING_SEPA_DD_MANDATE_NOT_FOUND = 'funding/sepa_dd_mandate_not_found';
export const FUNDING_SEPA_DD_NOT_AVAILABLE = 'funding/sepa_dd_not_available';

export const FUNDING_SEPA_DD_PAYMENT_SOURCE_NOT_FOUND = 'funding/sepa_dd_payment_source_not_found';

export const FUNDING_SEPA_DD_MANDATE_DOCUMENT_NOT_FOUND =
  'funding/sepa_dd_mandate_document_not_found';
export const FUNDING_SEPA_DD_MANDATE_TASK_NOT_FOUND = 'funding/sepa_dd_mandate_task_not_found';
export const FUNDING_SOF_TASK_REDUNDANT = 'funding/sof_task_redundant';
export const FUNDING_SOF_TASK_REQUIRED = 'funding/sof_task_required';
export const FUNDING_SOF_DOCUMENTS_REQUIRED = 'funding/sof_documents_required';
export const FUNDING_BANK_ACCOUNT_ALREADY_LINKED = 'funding/bank_account_already_linked';
export const FUNDING_BANK_ACCOUNT_HIGH_RISK_COUNTRY_NOT_ALLOWED =
  'funding/bank_account_high_risk_country_not_allowed';
export const FUNDING_BANK_ACCOUNT_BENEFICIARY_TASK_NOT_FOUND =
  'funding/bank_account_beneficiary_task_not_found';

export const PEA_DEPOSIT_LIMIT_REACHED = 'funding/pea_deposit_limit_reached';

export const INVESTMENT_PLANS_NOT_ENABLED = 'investment_plans/not_enabled';
export const INVESTMENT_PLANS_NOT_FOUND = 'investment_plans/not_found';
export const INVESTMENT_PLANS_ERROR_INVALID_INPUT = 'investment_plans/invalid_input';
export const INVESTMENT_PLANS_ERROR_INVALID_SELL_EXECUTION =
  'investment_plans/invalid_sell_execution';

export const INVESTMENT_PLANS_MAX_AMOUNT_ALLOCATION_EXCEEDED =
  'investment_plans/max_amount_allocation_exceeded';

export const USERS_DOCUMENTS_GENERATED_DOCUMENTS_MISSING =
  'users_documents/generated_documents_missing';

export const INVESTMENT_PLANS_ERROR_UNEXPECTED_INVESTMENT_ACCOUNT_TYPE =
  'investment_plans/unexpected_investment_account_type';

export const INVESTMENT_PLANS_INVALID_AGREED_TERMS = 'investment_plans/agreed_terms';

export const INVESTMENT_PLAN_TO_LOW_ALLOCATION = 'investment_plans/too_low_allocation';

export const INVESTMENT_PLAN_TO_MUCH_ALLOCATION = 'investment_plans/too_much_allocation';

export const INVESTMENT_PLAN_EMPTY_ALLOCATION = 'investment_plans/empty_allocation';

export const INVESTMENT_PLAN_ALLOCATION_NOT_INTEGER = 'investment_plans/allocation_not_integer';

export const INVESTMENT_PLAN_DUPLICATE_ALLOCATION = 'investment_plans/duplicate_allocation';

export const INVESTMENT_PLAN_INSUFFICIENT_ALLOCATION = 'investment_plans/insufficient_allocation';

export const INVESTMENT_PLAN_REACHED_LIMIT = 'investment_plan/reached_limit';
export const INVESTMENT_PLAN_TEMPLATES_REACHED_LIMIT = 'investment_plan_templates/reached_limit';

export const INVESTMENT_PLANS_TEMPLATES_NOT_FOUND = 'investment_plans_templates/not_found';

export const INVESTMENT_PLANS_TEMPLATE_INACTIVE = 'investment_plans_templates/inactive';

export const INVESTMENT_PLANS_TEMPLATE_ACCOUNT_TYPE_MISMATCH =
  'investment_plans_templates/account_type_mismatch';

export const INVESTMENT_PLANS_TEMPLATE_HORIZON_NOT_COVERED =
  'investment_plans_templates/horizon_not_covered';

export const AUTO_INVEST_ORDER_REACHED_LIMIT = 'auto_invest_order/reached_limit';

export const AUTO_INVEST_ORDER_AMOUNT_OVER_STG_LIMIT = 'auto_invest_order/amount_over_stg_limit';

export const INVESTMENT_PLANS_INVALID_FUTURE_EXECUTION_DATE =
  'investment_plans/invalid_future_execution_date';

export const INVESTMENT_PLANS_INVALID_EXECUTION_DATE_MARKET_CLOSED =
  'investment_plans/invalid_execution_date_market_closed';

export const INVESTMENT_PLANS_INVALID_EXECUTION_DATE_ALREADY_EXECUTED =
  'investment_plans/invalid_execution_date_already_executed';

export const INVESTMENT_PLANS_ERROR_INVALID_PAYMENT_METHOD =
  'investment_plans/invalid_payment_method';

export const INVESTMENT_PLANS_ERROR_INVALID_FREQUENCY = 'investment_plans/invalid_frequency';

export const MANAGED_INVESTMENT_PLAN_ALLOCATION_MISMATCH =
  'managed_investment_plan/allocation_mismatch';

export const INVESTMENT_PLANS_MANAGED_ERROR_INVALID_INPUT =
  'investment_plans_managed/invalid_input';

export const INVESTMENT_PLANS_MANAGED_ERROR_REACHED_LIMIT =
  'investment_plans_managed/reached_limit';

export const INVESTMENT_PLANS_MANAGED_NOT_EDITABLE = 'investment_plans_managed/not_editable';

export const INVESTMENT_PLANS_MANAGED_TEMPLATE_ERROR_REACHED_LIMIT =
  'investment_plans_managed_template/reached_limit';

export const INVESTMENT_PLAN_YEARS_TO_RETIREMENT_REQUIRED =
  'investment_plans/years_to_retirement_required';

export const INVESTMENT_PLAN_BIRTHDATE_REQUIRED = 'investment_plans/birthdate_required';

export const INVESTMENT_PLAN_USER_RETIRED = 'investment_plans/user_has_reached_retirement_age';

export const INVESTMENT_PLAN_RETIREMENT_AGE_BELOW_USER_AGE =
  'investment_plans/retirement_age_below_user_age';

export const INVESTMENT_PLAN_USER_ABOVE_MAX_AGE = 'investment_plans/user_above_max_age';

export const INVESTMENT_PLAN_PER_DEDUCTIBLE_AGE_LIMIT_EXCEEDED =
  'investment_plans/per_deductible_age_limit_exceeded';

export const INVESTMENT_PLAN_PER_DEDUCTIBILITY_EMPLOYMENT_STATUS_MISMATCH =
  'investment_plans/per_deductibility_employment_status_mismatch';

export const PAYMENT_METHOD_UNAUTHORIZED_CARD = 'payment_method/unauthorized_card';
export const PAYMENT_METHOD_UNSUPPORTED = 'payment_method/unsupported';

export const PRICE_ALERT_LIMIT_REACHED_PER_INSTRUMENT = 'price_alerts/limit_reached_per_instrument';
export const PRICE_ALERT_LIMIT_REACHED_TOTAL = 'price_alerts/limit_reached_total';

export const ASSET_LIST_LIMIT_REACHED_TOTAL = 'asset_list/limit_reached_total';
export const QA_ANNUAL_COSTS_REQUIREMENT_NOT_MET = 'qa/annual_costs_requirement_not_met';
export const QA_AUTOMATIC_ACTIVATION_WITHOUT_EMAIL = 'qa/automatic_activation_without_email';

export const PERIODIC_REVIEW_PERSONAL_DETAILS_NOT_FOUND =
  'periodic_review/personal_details/not_found';
export const PERIODIC_REVIEW_FINANCIAL_DETAILS_NOT_FOUND =
  'periodic_review/financial_details/not_found';

export const TRIGGERED_ORDERS_MAX_TRIGGERED_ORDERS_REACHED = 'triggered_orders/max_count_reached';
export const TRIGGERED_ORDERS_MAX_TRIGGERED_ORDERS_INSTRUMENT_REACHED =
  'triggered_orders/max_count_instrument_reached';
export const TRIGGERED_ORDERS_MAX_TRIGGERED_INVALID_MODEL = 'triggered_orders/invalid_model';
export const TRIGGERED_ORDERS_NOT_FOUND = 'triggered_orders/not_found';
export const TRIGGERED_ORDERS_INVALID_OPERATION = 'triggered_orders/invalid_operation';
export const TRIGGERED_ORDERS_OUT_OF_RANGE_TARGET_PRICE =
  'triggered_orders/out_of_range_target_price';
export const TRIGGERED_ORDERS_INVALID_USER = 'triggered_orders/invalid_user';
export const TRIGGERED_ORDERS_INVALID_STATUS = 'triggered_orders/invalid_status';
export const TRIGGERED_ORDERS_MONEY_ACTIONS_RESTRICTED =
  'triggered_orders/money_actions_restricted';

export const TRIGGERED_ORDERS_AMOUNT_OVER_STG_LIMIT = 'triggered_orders/amount_over_stg_limit';

export const TRIGGERED_ARBITRAGE_ORDERS_INVALID_OPERATION =
  'triggered_arbitrage_orders/invalid_operation';
export const PLANNED_WITHDRAWAL_ORDERS_INVALID_OPERATION =
  'planned_withdrawal_orders/invalid_operation';
export const PLANNED_WITHDRAWAL_ORDERS_OUT_OF_RANGE_TARGET_PRICE =
  'planned_withdrawal_orders/out_of_range_target_price';

export const TRIGGERED_ARBITRAGE_ORDERS_LIMIT_REACHED = 'triggered_arbitrage_orders/limit_reached';

export const TRIGGERED_ARBITRAGE_ORDERS_NOT_ALLOWED_FOR_INSTRUMENT =
  'triggered_arbitrage_orders/not_allowed_for_instrument';

export const AUTO_INVEST_MIN_MARKET_FUNDS_REQUIREMENT = 'auto_invest/min_market_funds_requirement';

export const EARLY_WITHDRAWAL_PENDING_ORDERS = 'employee_savings/withdrawal/pending_orders';

export const WITHDRAWAL_DECEASED_REQUIRES_THIRD_PARTY =
  'employee_savings/withdrawal/deceased_requires_third_party';

export const CA_EVENT_QTY_TOO_MANY_DECIMALS =
  'shares_corporate_actions/add_ca_event/qty_too_many_decimals';

export const WITHDRAWAL_NO_ORDERS_PLACED = 'employee_savings/withdrawal/no_orders_placed';

export const INVESTMENT_ACCOUNTS_PEA_NOT_ELIGIBLE = 'investment_accounts/pea/not_eligible';

export const INVESTMENT_ACCOUNTS_PEA_TOCS_NOT_APPROVED =
  'investment_accounts/pea/tocs_not_approved';

export const INVESTMENT_ACCOUNTS_PEA_ACCOUNT_EXISTS = 'investment_accounts/pea/pea_account_exists';

export const INVESTMENT_ACCOUNTS_PEA_PENDING_APPROVAL = 'investment_accounts/pea/pending_approval';

export const INVESTMENT_ACCOUNTS_NOT_READY_FOR_INVESTMENT =
  'investment_accounts/not_ready_for_investment';

export const INVESTMENT_ACCOUNTS_PEA_MISSING_TAX_NUMBER =
  'investment_accounts/pea/missing_tax_number';

export const INVESTMENT_ACCOUNTS_PEA_NO_ACCOUNT_FOUND = 'investment_accounts/pea/no_account_found';

export const INVESTMENT_ACCOUNTS_PER_NOT_ELIGIBLE = 'investment_accounts/per/not_eligible';

export const INVESTMENT_ACCOUNTS_PER_TOCS_NOT_APPROVED =
  'investment_accounts/per/tocs_not_approved';

export const INVESTMENT_ACCOUNTS_NON_ACQUIRED_FEE_PERCENT_REQUIRED =
  'investment_accounts/non_acquired_fee_percent_required';

export const INVESTMENT_ACCOUNTS_NON_ACQUIRED_FEE_PERCENT_THRESHOLD_REACHED =
  'investment_accounts/non_acquired_fee_percent_threshold_reached';

export const INVESTMENT_ACCOUNTS_PER_ACCOUNT_EXISTS = 'investment_accounts/per/per_account_exists';
export const INVESTMENT_ACCOUNTS_PER_MISSING_ACKNOWLEDGEMENTS =
  'investment_accounts/per/missing_acknowledgements';

export const INVESTMENT_ACCOUNTS_PER_INVALID_EMPLOYMENT_QUESTIONNAIRE =
  'investment_accounts/per/invalid_employment_questionnaire';

export const INVESTMENT_ACCOUNTS_PER_PENDING_INITIAL_CONTRIBUTION =
  'investment_accounts/per/pending_initial_contribution';

export const INVESTMENT_PLANS_PENDING_APPROVAL = 'investment_plans/pending_approval';

export const INVESTMENT_PLANS_PENDING_CANCELLATION_APPROVAL =
  'investment_plans/pending_cancellation_approval';

export const INVESTMENT_PLANS_ZERO_ALLOCATION = 'investment_plans/zero_allocation';

export const INVESTMENT_PLANS_PENDING_PAUSE_APPROVAL = 'investment_plans/pending_pause_approval';

export const INVESTMENT_PLANS_PENDING_RESUME_APPROVAL = 'investment_plans/pending_resume_approval';

export const INVESTMENT_PLANS_PENDING_UPDATE_APPROVAL = 'investment_plans/pending_update_approval';

export const INVESTMENT_PLANS_PENDING_EXECUTION_APPROVAL =
  'investment_plans/pending_execution_approval';

export const INVESTMENT_PLANS_UNSUPPORTED_INTENT = 'investment_plans/unsupported_intent';

export const INVESTMENT_PLANS_NOT_APPROVED_YET = 'investment_plans/not_approved_yet';

export const INVESTMENT_PLANS_EXECUTION_IN_PROGRESS = 'investment_plans/execution_in_progress';

export const INVESTMENT_PLANS_PER_ALREADY_INVESTED = 'investment_plans/per_already_invested';

export const INVESTMENT_PLANS_PAUSED = 'investment_plans/paused';

export const INVESTMENT_PLANS_UNEXPECTED_BEHAVIOR = 'investment_plans/unexpected_behavior';

export const INVESTMENT_PLAN_COMPLEX_INSTRUMENT_REQUIRES_PGP =
  'investment_plans/complex_instrument_requires_pgp';

export const INVESTMENT_PLAN_PER_CONTAINS_FRACTIONAL_STOCKS =
  'investment_plans/per_contains_fractional_stocks';

export const INVESTMENT_ACCOUNTS_PEA_INVALID_INPUT = 'investment_accounts/pea/invalid_input';

export const INVESTMENT_ACCOUNTS_NOT_FOUND = 'investment_accounts/no_account_found';

export const INVESTMENT_ACCOUNTS_PEA_INSTRUMENT_NOT_ELIGIBLE =
  'investment_accounts/pea/instrument_not_eligible';

export const INVESTMENT_ACCOUNTS_PEA_UNEXPECTED_BEHAVIOR =
  'investment_accounts/pea/unexpected_behavior';

export const INVESTMENT_ACCOUNTS_PER_UNEXPECTED_BEHAVIOR =
  'investment_accounts/per/unexpected_behavior';

export const INVESTMENT_ACCOUNT_NOT_IN_EXPECTED_STATUS =
  'investment_account/not_in_expected_status';

export const INVESTMENT_ACCOUNT_NOT_SUPPORTED = 'investment_account/not_supported';

export const APPROVAL_REQUEST_EXPIRED = 'approval_request/expired';
export const APPROVAL_REQUEST_CANCELED = 'approval_request/canceled';

export const APPROVAL_REQUEST_ALREADY_APPROVED = 'approval_request/already_approved';

export const APPROVAL_REQUEST_DOCUMENTS_NOT_FOUND = 'approval_request/documents_not_found';

export const WEALTH_MANAGER_ADMIN_NOT_FOUND = 'wealth_manager/admin_not_found';
export const WEALTH_MANAGER_UNAUTHORIZED_CUSTOMER_ACCESS =
  'wealth_manager/unauthorized_customer_access';
export const WEALTH_MANAGER_CUSTOMER_NOT_FOUND = 'wealth_manager/customer_not_found';
export const WEALTH_MANAGER_CUSTOMER_EMAIL_DOMAIN_NOT_SUPPORTED =
  'wealth_manager/customer_email_domain_not_supported';
export const WEALTH_MANAGER_CUSTOMER_EMAIL_ALREADY_TAKEN =
  'wealth_manager/customer_email_already_taken';
export const WEALTH_MANAGER_CUSTOMER_PHONE_NUMBER_ALREADY_EXIST =
  'wealth_manager/customer_phone_number_already_exist';
export const WEALTH_MANAGER_CUSTOMER_BANK_ACCOUNT_NOT_FOUND =
  'wealth_manager/customer_bank_account_not_found';
export const WEALTH_MANAGER_CUSTOMER_BANK_DETAILS_NOT_FOUND =
  'wealth_manager/customer_bank_details_not_found';
export const WEALTH_MANAGER_CUSTOMER_SEPA_MANDATE_ALREADY_EXISTS =
  'wealth_manager/customer_sepa_mandate_already_exists';
export const WEALTH_MANAGER_CUSTOMER_SEPA_MANDATE_NOT_FOUND =
  'wealth_manager/customer_sepa_mandate_not_found';
export const WEALTH_MANAGER_QUESTIONS_ERROR_UBO_LIST_UNAVAILABLE =
  'wealth_manager/questions/company/ubo_list_unavailable';
export const WEALTH_MANAGER_QUESTIONS_ERROR_DIRECTORS_LIST_UNAVAILABLE =
  'wealth_manager/questions/company/directors_list_unavailable';
export const WEALTH_MANAGER_CUSTOMER_INVESTING_EXPERIENCE_QUESTIONNAIRE_NOT_FOUND =
  'wealth_manager/questions/customers/investing_experience_questionnaire_not_found';
export const WEALTH_MANAGER_CUSTOMER_INVESTING_EXPERIENCE_QUESTIONNAIRE_ALREADY_APPROVED =
  'wealth_manager/questions/customers/investing_experience_questionnaire_already_approved';
export const WEALTH_MANAGER_CUSTOMER_INVALID_QUESTIONNAIRE =
  'wealth_manager/customers/invalid_questionnaire';
export const WEALTH_MANAGER_CUSTOMER_QUESTIONNAIRE_ALREADY_EXISTS =
  'wealth_manager/customers/questionnaire_already_exists';
export const WEALTH_MANAGER_CUSTOMER_INVALID_INVESTMENT_STRATEGY =
  'wealth_manager/customers/invalid_investment_strategy';
export const WEALTH_MANAGER_CUSTOMER_COMPANY_EXISTS = 'wealth_manager/customers/company_exists';
export const WEALTH_MANAGER_CUSTOMER_COMPANY_INVALID_LEGAL_CATEGORY =
  'wealth_manager/customers/company_invalid_legal_category';
export const WEALTH_MANAGER_CUSTOMER_DOCUMENT_UPLOAD_FORBIDDEN =
  'wealth_manager/customers/document_upload_forbidden';
export const WEALTH_MANAGER_CUSTOMER_DOCUMENT_PERSON_ID_BUSINESS_POI_ONLY =
  'wealth_manager/customers/document_person_id_business_poi_only';
export const WEALTH_MANAGER_CUSTOMER_DOCUMENT_PERSON_ID_INVALID =
  'wealth_manager/customers/document_person_id_invalid';
export const WEALTH_MANAGER_CUSTOMER_DOCUMENT_ALREADY_UPLOADED =
  'wealth_manager/customers/document_already_uploaded';
export const WEALTH_MANAGER_CUSTOMER_POSOF_TASK_NOT_FOUND =
  'wealth_manager/customers/posof_task_not_found';
export const WEALTH_MANAGER_CUSTOMER_POSOF_ALREADY_SUBMITTED =
  'wealth_manager/customers/posof_already_submitted';
export const WEALTH_MANAGER_CUSTOMER_POSOF_DETAILED_DOCUMENTS_FORBIDDEN =
  'wealth_manager/customers/posof_detailed_documents_forbidden';
export const WEALTH_MANAGER_CUSTOMER_POSOF_INVALID_DETAILED_DOCUMENTS =
  'wealth_manager/customers/posof_invalid_detailed_documents';
export const WEALTH_MANAGER_CUSTOMER_DOCUMENT_NOT_FOUND =
  'wealth_manager/customers/document_not_found';
export const WEALTH_MANAGER_CUSTOMER_DOCUMENTS_EXPORT_EMPTY =
  'wealth_manager/customers/documents_export_empty';
export const WEALTH_MANAGER_DOCUMENT_NOT_FOUND = 'wealth_manager/document_not_found';
export const WEALTH_MANAGER_ORDERS_NOT_CANCELABLE = 'wealth_manager/orders/not_cancelable';
export const WEALTH_MANAGER_CUSTOMER_BANK_ACCOUNT_ALREADY_TAKEN =
  'wealth_manager/customers/bank_account_already_taken';
export const WEALTH_MANAGER_CUSTOMER_SEPA_MANDATE_SIGNATURE_REQUIRED =
  'wealth_manager/customers/sepa_mandate_signature_required';
export const WEALTH_MANAGER_CUSTOMER_DRAFT_NOT_FOUND = 'wealth_manager/customers/drafts/not_found';
export const WEALTH_MANAGER_SEPA_DD_NOT_SUPPORTED = 'wealth_manager/sepa_dd/not_supported';
export const WEALTH_MANAGER_INVALID_FEE = 'wealth_manager/invalid_fee';
export const WEALTH_MANAGER_ADMIN_EMAIL_ALREADY_TAKEN = 'wealth_manager/admins/email_already_taken';
export const WEALTH_MANAGER_ADMIN_COMPANY_DATA_NOT_ALLOWED =
  'wealth_manager/admins/wealth_manager_admin_company_data_not_allowed';
export const WEALTH_MANAGER_ADMIN_COMPANY_DATA_REQUIRED =
  'wealth_manager/admins/wealth_manager_admin_company_data_required';
export const WEALTH_MANAGER_ADMIN_WM_COMPANY_NOT_ACCESSIBLE =
  'wealth_manager/admins/wm_company_not_accessible';
export const WEALTH_MANAGER_ENTITY_ALREADY_EXISTS = 'wealth_manager/entities/already_exists';
export const WEALTH_MANAGER_ENTITY_PARENT_NOT_ACCESSIBLE =
  'wealth_manager/entities/parent_not_accessible';

export const GENERAL_INVALID_REQUEST = 'general/invalid_request';

export const TRANSACTIONS_DIVIDEND_NOT_FOUND_ERROR = 'transactions/dividend_not_found';
export const TRANSACTIONS_MERGER_NOT_FOUND_ERROR = 'transactions/merger_not_found';
export const TRANSACTIONS_CAPITAL_INCREASE_NOT_FOUND_ERROR =
  'transactions/capital_increase_not_found';
export const TRANSACTIONS_SPINOFF_NOT_FOUND_ERROR = 'transactions/spinoff_not_found';

export const TRANSACTIONS_OMNIBUS_DIVIDEND_NOT_FOUND_ERROR =
  'transactions/omnibus_dividend_not_found';
export const TRANSACTIONS_CARD_TOP_UP_NOT_FOUND_ERROR = 'transactions/card_top_up_not_found';
export const TRANSACTIONS_COINBASE_ORDER_NOT_FOUND_ERROR = 'transactions/coinbase_order_not_found';
export const TRANSACTIONS_UPVEST_ORDER_NOT_FOUND_ERROR = 'transactions/upvest_order_not_found';
export const TRANSACTIONS_ALPACA_ORDER_NOT_FOUND_ERROR = 'transactions/alpaca_order_not_found';
export const TRANSACTIONS_INVESTMENT_PLAN_ORDER_NOT_FOUND_ERROR =
  'transactions/investment_plan_order_not_found';
export const TRANSACTIONS_AUTO_INVEST_ORDER_NOT_FOUND_ERROR =
  'transactions/auto_invest_order_not_found';
export const TRANSACTIONS_ODDO_ORDER_NOT_FOUND_ERROR = 'transactions/oddo_order_not_found';
export const TRANSACTIONS_SKIPPED_ALLOCATION_NOT_FOUND_ERROR =
  'transactions/skipped_allocation_not_found';
export const TRANSACTIONS_MATERIALIZED_ORDER_NOT_FOUND_ERROR =
  'transactions/materialized_order_not_found';
export const TRANSACTIONS_TRIGGERED_ORDER_NOT_FOUND_ERROR =
  'transactions/triggered_order_not_found';
export const TRANSACTIONS_PLANNED_WITHDRAWAL_ORDER_NOT_FOUND_ERROR =
  'transactions/planned_withdrawal_order_not_found';
export const TRANSACTIONS_VOLUNTARY_PAYMENT_ORDER_NOT_FOUND_ERROR =
  'transactions/voluntary_payment_order_not_found';
export const TRANSACTIONS_HISTORICAL_TRANSACTION_NOT_FOUND =
  'transactions/historical_transaction_not_found';
export const TRANSACTIONS_MATERIALIZED_ORDER_FORMATTING_ERROR =
  'transactions/materialized_order_formatting_error';

export const TRANSACTIONS_B2B_INCOMING_EXTERNAL_TRANSFER_NOT_FOUND_ERROR =
  'transactions/b2b_incoming_external_transfer_not_found';

export const INSTRUMENT_CHANGED_MARKET_SYMBOL = 'instrument/changed_market_symbol';

export const FACTSET_DATA_MISSING = 'factset/data_missing';
export const EMPLOYEE_SAVINGS_NOT_FOUND = 'employee_savings/not_found';
export const EMPLOYEE_SAVINGS_AUTH_ALREADY_ACTIVATED = 'employee_savings/auth_already_activated';

export const MAX_ORDER_AMOUNT_EXCEEDED = 'explore/max_order_amount_exceeded';

export const INCOMING_TRANSFER_ERROR_INVALID_INPUT = 'incoming_transfer/invalid_input';
export const INCOMING_TRANSFER_NOT_FOUND = 'incoming_transfer/not_found';
export const INCOMING_TRANSFER_INSUFFICIENT_TARGET = 'incoming_transfer/insufficient_target';
export const INCOMING_TRANSFER_TOO_MUCH_TARGET = 'incoming_transfer/too_much_target';
export const INCOMING_TRANSFER_DUPLICATE_TARGET = 'incoming_transfer/duplicate_target';
export const INCOMING_TRANSFER_DOCUMENTS_ALREADY_UPLOADED =
  'incoming_transfer/documents_already_uploaded';
export const INCOMING_TRANSFER_INCOMPATIBLE_CATEGORIES =
  'incoming_transfer/incompatible_categories';
export const INCOMING_TRANSFER_MISSING_ACKNOWLEDGEMENTS =
  'incoming_transfer/missing_acknowledgements';
export const INCOMING_TRANSFER_RESEND_EMAIL_TOO_SOON = 'incoming_transfer/resend_email_too_soon';
export const INCOMING_TRANSFER_RESEND_EMAIL_NOT_ALLOWED =
  'incoming_transfer/resend_email_not_allowed';

export const WM_ORDERS_ERROR_INVALID_INPUT = 'orders/invalid_input';

export const WM_APPROVAL_REQUEST_NOT_ACTIONABLE = 'wm_approval_request/not_actionable';

export const WM_APPROVAL_REQUEST_NOT_EXPECTED_TYPE = 'wm_approval_request/not_expected_type';

export const ROBO_ADVISOR_PROFILE_EXPIRED = 'robo_advisor/profile_expired';

export const ROBO_ADVISOR_PROFILE_NOT_FOUND = 'robo_advisor/profile_not_found';

export const ER_INVESTMENT_INVALID_POLICY_NUMBER = 'er_investment/invalid_policy_number';
export const ER_INVESTMENT_FUND_LIMITATION_NOT_RESPECTED =
  'er_investment/fund_limitation_not_respected';
export const ER_ONGOING_ARBITRAGE_ON_SAME_COMPARTMENT =
  'er_investment/ongoing_arbitrage_on_same_compartment';
export const ER_COMPARTMENT_NOT_AVAILABLE_ON_POLICY =
  'er_investment/compartment_not_available_on_policy';
export const ER_FINANCIAL_MANAGEMENT_BLOCKED_ON_COMPARTMENT =
  'er_investment/financial_management_blocked_on_compartment';
export const ER_FUTURE_ALLOCATION_NOT_AVAILABLE = 'er_investment/future_allocation_not_available';
export const ER_FUTURE_ALLOCATION_NOT_DEROGABLE = 'er_investment/future_allocation_not_derogable';
export const ER_FUTURE_ALLOCATION_INVALID_ALLOCATION =
  'er_investment/future_allocation_invalid_allocation';

export const B2B_INVESTOR_PROFILE_ALLOCATIONS_ARE_REQUIRED =
  'b2b/investor_profile/allocations_are_required';

export const B2B_INVESTOR_PROFILE_MISSING_DEFAULT_GRID =
  'b2b/investor_profile/allocations_are_required';
export const B2B_INVESTOR_PROFILE_INVALID_RISK_PROFILE =
  'b2b/investor_profile/invalid_risk_profile';

export const B2B_INVESTOR_PROFILE_DUPLICATE_MIN_YEARS_TO_RETIREMENT_VALUES_FOUND =
  'b2b/investor_profile/duplicate_min_years_to_retirement_values_found';

export const B2B_INVESTOR_PROFILE_MIN_YEARS_TO_RETIREMENT_MUST_BE_LOWER_THAN_OR_EQUAL_TO_25 =
  'b2b/investor_profile/min_years_to_retirement_must_be_lower_than_or_equal_to_25';

export const B2B_INVESTOR_PROFILE_DUPLICATE_INSTRUMENT_ID_VALUES_FOUND =
  'b2b/investor_profile/duplicate_instrument_id_values_found';

export const B2B_INVESTOR_PROFILE_SUM_OF_ALLOCATION_PERCENT_MUST_EQUAL_EXACTLY_100 =
  'b2b/investor_profile/sum_of_allocation_percent_must_equal_exactly_100';

export const B2B_INVESTOR_PROFILE_INVALID_INSTRUMENT_UNIVERSE =
  'b2b/investor_profile/invalid_instrument_universe.only_mutual_funds_are_allowed';

export const B2B_COMPANY_PLAN_DEFAULT_FUND_NOT_IN_INSTRUMENTS_UNIVERSE =
  'b2b/company_plan/default_fund_instrument_id_must_belong_to_the_instruments_universe';

export const B2B_COMPANY_PLAN_LABEL_LOCKED_BY_DEFAULT_ALLOCATION_RULE =
  'b2b/company_plan/plan_label_locked_by_default_allocation_rule';

export const B2B_INVESTOR_PROFILE_ONLY_ONE_ALLOCATION_ALLOWED =
  'b2b/investor_profile/only_one_allocation_allowed';

export const B2B_INVESTOR_PROFILE_FIX_ALLOCATION_AMOUNT_EXPECTED =
  'b2b/investor_profile/fix_allocation_amount_expected';

export const B2B_INVESTOR_PROFILE_PEE_INVALID_INPUT = 'b2b/investor_profile/pee/invalid_input';

export const B2B_RECURRING_INVESTMENT_LIBRE_MISSING_ALLOCATIONS =
  'b2b/recurring_investment/libre/missing_allocations';
export const B2B_RECURRING_INVESTMENT_MANAGED_MISSING_AMOUNT =
  'b2b/recurring_investment/managed/missing_amount';
export const B2B_RECURRING_INVESTMENT_LIMIT_EXCEEDED = 'b2b/recurring_investment/limit_exceeded';

export const B2B_RECURRING_INVESTMENT_NOT_FOUND = 'b2b_recurring_investment/not_found';

export const USER_NOT_ELIGIBLE_FOR_PEA_TRANSFER = 'user/not_eligible_for_pea_transfer';
export const THIS_REQUEST_IS_NOT_ACTIONABLE = 'this_request_is_not_actionable';

export const INVESTMENT_PLANS_UNEXPECTED_AGREED_TERMS = 'investment_plans/unexpected_agreed_terms';
export const WM_CUSTOMER_INVOICE_NOT_SUPPORTED = 'wm_customer_invoice/not_supported';

export const B2B_CCB_INVALID_INSTRUMENT_UNIVERSE =
  'b2b/plans/ccb_instrument_universe_contains_invalid_instruments';

export const SEPA_PAYMENT_MAX_AMOUNT = 'wm_orders/sepa_payment_max_amount';

export const FILE_EXTENSION_CONTROL_FAILED = 'file/invalid_format';
export const FILE_IS_PASSWORD_PROTECTED = 'file/password_protected';

export const B2C_TRANSFER_REQUEST_ALREADY_OPEN = 'b2c_transfer_request/already_open';
